import ds from './DataSourceService'

const baseUrl = '/admin'

const getAllUsers = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/get-users')
}

const getAllProjects = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/get-projects')
}

const getAllUsersForProject = (projectId, userRole) => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/project/' + projectId + '/get-users?userRole=' + userRole
  )
}

const createUserWithRole = data => {
  return ds.apiClientThinkHome.post(baseUrl + '/create-user', data)
}
const createUserWithRoleForProject = (data, projectId) => {
  var host = window.location.protocol + '//' + window.location.host
  return ds.apiClientThinkHome.post(
    baseUrl + '/create-user?projectId=' + projectId + '&role=' + data.role,
    {
      userData: data,
      hostAddress: host
    }
  )
}

const updateUserWithUserRole = data => {
  return ds.apiClientThinkHome.patch(baseUrl + '/update-user', data)
}

const deleteUser = userId => {
  return ds.apiClientThinkHome.delete(baseUrl + '/delete-user', {
    data: { userId: userId }
  })
}

export default {
  getAllUsers,
  getAllProjects,
  getAllUsersForProject,
  createUserWithRole,
  createUserWithRoleForProject,
  updateUserWithUserRole,
  deleteUser
}
